import { render, staticRenderFns } from "./Stacks.vue?vue&type=template&id=22e67e39&scoped=true&"
import script from "./Stacks.vue?vue&type=script&lang=js&"
export * from "./Stacks.vue?vue&type=script&lang=js&"
import style0 from "./Stacks.vue?vue&type=style&index=0&id=22e67e39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e67e39",
  null
  
)

export default component.exports